import { useMutation } from "@tanstack/react-query";
import { useContext } from "react";
import UserContext from "../../context/user";

const useEventCreateMutation = (setEventNavigation, setReservation, appLang) => {
  const { callApi } = useContext(UserContext);

  return useMutation(
    ({ eventId, formData, stage }) =>
      callApi(`/events/${eventId}/registrations`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          eventStageId: Number(formData.stage),
          ...(formData.email ? { email: formData.email } : {}),
          ...(stage?.guestAllowed
            ? formData["guest_name"]
              ? { guestFullName: formData["guest_name"] }
              : {}
            : {}),
          ...(stage?.transferAllowed ? (formData.transfer ? { transferNeeded: true } : {}) : {}),
        }),
      }),
    {
      onSuccess: (data) => {
        setReservation(data);
        if (["REGISTERED", "QUEUED"]?.includes(data?.status))
          setEventNavigation({
            url: data?.status === "REGISTERED" ? "booked" : "waiting-list",
          });
      },
    }
  );
};

export default useEventCreateMutation;
